import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login'; // Angenommen, du hast eine Login-Komponente
import MainPage from './pages/MainPage';
import './App.css';
import SignIn from './pages/SignIn';
import PayPage from './pages/PayPage';
import TestTimePage from './pages/TestTimePage';
import ForgetPassword from './pages/ForgetPasswordPage';
import ChangePassword from './pages/ChangePasswordPage';
import Settings from './pages/Settings'
import Footer from './pages/Footer';
import UnitsSettings from './pages/UnitsSettings';

function App() {
  const [loggedState, setLoggedState] = useState<number>(0);
  const [tag, setTag] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [token, setToken] = useState<string>('');
  const [accountStatus, setAccountStatus] = useState<string>('');
  const [testAlarms, setTestAlarms] = useState<number>(0);
  const [agbStatus, setAGBStatus] = useState<number>(0);
  const [dsgvoStatus, setDSGVOStatus] = useState<number>(0);
  const [useCondStatus, setUseCondStatus] = useState<number>(0);
  const [loggedID, setLoggedID] = useState<string>('');
  const [alarmMonitorURL, setAlarmMonitorURL,] = useState<string>('');
  document.title = "JuniorAlarm";

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="*" element={<Login setloggedState={setLoggedState} setloggedID={setLoggedID} setTag={setTag} setName={setName} setToken={setToken} setAccountStatus={setAccountStatus} setTestAlarms={setTestAlarms} setAGBStatus={setAGBStatus} setDSGVOStatus={setDSGVOStatus} setUseCondStatus={setUseCondStatus} setAlarmMonitorURL={setAlarmMonitorURL}/>} />
          <Route path="/ForgetPassword" element={<ForgetPassword />} />
          <Route path="/MainPage" element={<MainPage tag={tag} name={name} loggedState={loggedState} loggedID={loggedID} setloggedState={setLoggedState} testAlarms={testAlarms} agbStatus={agbStatus} dsgvoStatus={dsgvoStatus} useCondStatus={useCondStatus} alarmMonitorURL={alarmMonitorURL} />} />
          <Route path="/ChangePassword" element={<ChangePassword tag={tag}/>} />
          <Route path="/SignIn" element={<SignIn />} />
          <Route path="/TestTime" element={<TestTimePage />} />
          <Route path="/PayPage" element={<PayPage tag={tag}/>} />
          <Route path="/Settings" element={<Settings token={token} accountStatus={accountStatus} testAlarms={testAlarms}/>} />
          <Route path="/UnitsSettings" element={<UnitsSettings loggedState={loggedState} loggedID={loggedID}/>} />
        </Routes>
      </Router>
    
      <Footer></Footer>
    </div>
    
  );
}

export default App;

